import React from 'react';
import styles from '../../AgentForm.module.scss';

const SelectOptionsMessage = () => {
  return (
    <div className={styles.formMessage}>
      <p className={styles.formText}>Please select agent access and </p>
      <p className={styles.formText}>agency code to add other details</p>
    </div>
  );
};

export default SelectOptionsMessage;
